import { AppState } from '../../root-reducer';

export const selectSatelliteOverlays = (state: AppState) => state.satelliteOverlayDomain.satelliteOverlays;
